import React from "react";
import { FaDiceSix } from "@react-icons/all-files/fa/FaDiceSix";
import { FaBolt } from "@react-icons/all-files/fa/FaBolt";
import { FaDragon } from "@react-icons/all-files/fa/FaDragon";
import { BulletIcon } from "../icons/BulletIcon";
import { ModeIds, VARIANT_CHESS960 } from "@chesshotel/constants";
import { FullLeagueScore } from "@chesshotel/types";

export function formatTime(time, inc) {
  const incText = inc > 0 ? ` + ${inc}s` : "";
  return `${time}m${incText}`;
}

function getTwoDigitDateFormat(monthOrDate) {
  return monthOrDate < 10 ? "0" + monthOrDate : "" + monthOrDate;
}

export function formatDate(date) {
  const d = new Date(date);
  return (
    d.getFullYear() +
    "-" +
    getTwoDigitDateFormat(d.getMonth() + 1) +
    "-" +
    getTwoDigitDateFormat(d.getDate())
  );
}

export function getModeIcon(modeId) {
  if (modeId === ModeIds.CHESS960) {
    return <FaDiceSix />;
  } else if (modeId === ModeIds.BULLET) {
    return <BulletIcon />;
  } else if (modeId === ModeIds.BLITZ) {
    return <FaBolt />;
  } else if (modeId === ModeIds.RAPID) {
    return <FaDragon />;
  }
}

export function firstToUpper(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getModeId(time, variant) {
  if (variant === VARIANT_CHESS960) {
    return ModeIds.CHESS960;
  } else if (time < 3) {
    return ModeIds.BULLET;
  } else if (time < 10) {
    return ModeIds.BLITZ;
  } else {
    return ModeIds.RAPID;
  }
}

export function getModeName(modeId) {
  if (modeId === ModeIds.CHESS960) {
    return "CHESS960";
  } else if (modeId === ModeIds.BULLET) {
    return "BULLET";
  } else if (modeId === ModeIds.BLITZ) {
    return "BLITZ";
  } else {
    return "RAPID";
  }
}

export function getModeNameCapitalFirst(modeId) {
  if (modeId === ModeIds.CHESS960) {
    return "Chess960";
  } else if (modeId === ModeIds.BULLET) {
    return "Bullet";
  } else if (modeId === ModeIds.BLITZ) {
    return "Blitz";
  } else if (modeId === ModeIds.RAPID) {
    return "Rapid";
  } else {
    return "Correspondence";
  }
}

export function getHeighestScore(scores: FullLeagueScore[]) {
  if (scores == null || scores.length === 0) {
    return null;
  }
  let highestElo = scores[0].elo;
  let highestScore = scores[0];
  for (let i = 0; i < scores.length; i++) {
    const score = scores[i];
    if (highestElo < score.elo) {
      highestElo = score.elo;
      highestScore = score;
    }
  }
  return highestScore;
}
